import { useEffect } from "react"
import { useMap } from "react-leaflet";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import * as L from "leaflet";
import 'leaflet.locatecontrol';

const UserLocate = () => {
  const map = useMap();

  useEffect(() => {
    L.control
    .locate({
      position: "topright",
      strings: {
        title: "Ga naar huidige locatie",
      },
      showPopup: false
    })
    .addTo(map);
  }, [])
  return null;
};

export default UserLocate;